import { NavLink, Outlet } from "react-router-dom";
import { Boxes, Package, ClipboardList, Activity, Layers } from "lucide-react";

const TABS = [
  { to: "/housekeeping/inventory",          label: "HK Inventory",     icon: Package,       end: true, testid: "hkinv-tab-inventory" },
  { to: "/housekeeping/inventory/requests", label: "Storage Requests", icon: ClipboardList,            testid: "hkinv-tab-requests" },
  { to: "/housekeeping/inventory/floors",   label: "Floor Pars",       icon: Layers,                   testid: "hkinv-tab-floors" },
  { to: "/housekeeping/inventory/usage",    label: "Usage Log",        icon: Activity,                 testid: "hkinv-tab-usage" },
];

export default function HKInventoryShell() {
  return (
    <div className="space-y-6" data-testid="hkinv-shell">
      <div className="flex items-baseline gap-3">
        <div className="w-11 h-11 rounded-xl bg-hocp-gold flex items-center justify-center shrink-0">
          <Boxes className="w-5 h-5 text-hocp-eerie" strokeWidth={2}/>
        </div>
        <div>
          <h1 className="font-display text-[26px] font-bold text-hocp-navy leading-none">Housekeeping Inventory</h1>
          <p className="text-[13px] text-slate-500 mt-1.5">
            Room supplies · Storage requests · Issuance &amp; auto stock update · Usage per room / floor.
          </p>
        </div>
      </div>
      <div className="flex gap-1 border-b border-slate-200 overflow-x-auto">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-2.5 text-[13px] font-medium border-b-2 whitespace-nowrap ${
                  isActive ? "border-hocp-navy text-hocp-navy" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}>
              <Icon className="w-4 h-4" strokeWidth={1.75}/>{t.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet/>
    </div>
  );
}
